import { useCallback } from 'react';
import { useResourceCollection, useCreateResource, useUpdateResource, useDeleteResource, ResourceState, MutationState } from './useResource';
import { contactOfficesService } from '../services';
import { ContactOffice } from '../types';
import { ResourceQueryOptions } from '../services/resources.service';

export function useContactOffices(options?: ResourceQueryOptions): ResourceState<ContactOffice> & { meta?: any } {
  const fetchFn = useCallback(
    (opts?: ResourceQueryOptions) =>
      contactOfficesService.getAll(opts) as unknown as Promise<{ data: ContactOffice[]; meta?: any }>,
    []
  );
  return useResourceCollection<ContactOffice>(fetchFn, options);
}

export function useCreateContactOffice(onSuccess?: () => void): MutationState<ContactOffice> {
  return useCreateResource<ContactOffice>(contactOfficesService.create, onSuccess);
}

export function useUpdateContactOffice(onSuccess?: () => void): MutationState<ContactOffice> {
  return useUpdateResource<ContactOffice>(contactOfficesService.update, onSuccess);
}

export function useDeleteContactOffice(onSuccess?: () => void): MutationState<void> {
  return useDeleteResource(contactOfficesService.delete, onSuccess);
}
